import React from 'react'
import { connect } from 'react-redux'
import { VenderInfoContainer } from './styled'
import { compose, lifecycle } from 'recompose'
import { reduxForm, getFormValues, Field, FieldArray } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Paper, IconButton, Button } from '@material-ui/core'
import { Delete, Add } from '@material-ui/icons'

const renderContacts = ({ fields, meta: { error } }) => {
  return (
    <div style={{ marginTop: '10px' }}>
      <h3 style={{ margin: 0 }}>Contact Persons</h3>
      {
        fields.map((contact, index) => {
          return (
            <Paper style={{ padding: '15px', marginTop: '10px' }}>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold' }}>Person {index+1}</span>
                <IconButton style={{ color: 'red' }} aria-label='Delete' onClick={() => fields.remove(index)}>
                  <Delete fontSize='small' />
                </IconButton>
              </div>
              <Field name={`${contact}.name`} label='Contact Name' type={type.text} component={FieldInput} />
              <div style={{ display: 'flex', width: '100%' }}>
                <Field name={`${contact}.telephone`} label='Tel' type={type.text} containerStyle={{ flex: 3 }} component={FieldInput} />
                <Field name={`${contact}.extention`} label='Ext.' type={type.text} containerStyle={{ flex: 2 }} style={{ marginLeft: '10px' }} component={FieldInput} />
                <Field name={`${contact}.mobile`} label='Mobile' type={type.text} containerStyle={{ flex: 5 }} style={{ marginLeft: '10px' }} component={FieldInput} />
              </div>
              <Field name={`${contact}.email`} label='Email' type={type.text} component={FieldInput} />
            </Paper>
          )
        })
      }
      <Button 
        type='button' 
        style={{ marginTop: '10px' }}
        variant='contained' 
        color='primary' 
        onClick={() => fields.push({})}>
        <Add fontSize='small' />
        Add Contact Person
      </Button>
    </div>
  )
}

const MinVenderInfomationForm = (props) => {
  return (
    <VenderInfoContainer>
      <Paper style={{ padding: '15px', marginTop: '10px' }}>
      <h1 style={{ margin: 0 }}>Company Information</h1>
      <form>
        <Field name='companyName'
          label='Company Name'
          placeHolder='Your company name.'
          type={type.text} 
          component={FieldInput} />
        <div className='address'>
          <Field name='address'
            label='Address'
            type={type.textArea} 
            containerStyle={{ flex: 1 }}
            component={FieldInput} />
          <Field name='zipCode'
            label='Zip Code'
            type={type.text} 
            style={{ width: '120px', marginLeft: '10px' }}
            component={FieldInput} />
        </div>
        <div className='tel'>
          <Field name='telephone'
            label='Tel'
            type={type.text} 
            containerStyle={{ flex: 3 }}
            component={FieldInput} />
          <Field name='extension'
            label='Ext.'
            type={type.text} 
            containerStyle={{ flex: 2 }}
            style={{ marginLeft: '10px' }}
            component={FieldInput} />
          <Field name='mobile'
            label='Mobile'
            type={type.text} 
            containerStyle={{ flex: 5 }}
            style={{ marginLeft: '10px' }}
            component={FieldInput} />
        </div>
        <FieldArray name='contacts' component={renderContacts} />
      </form>
      </Paper>
    </VenderInfoContainer>
  )
}

const validate = values => {
  const errors = {}
  if (!values.companyName) {
    errors.companyName = 'Required!'
  }

  return errors
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formVenderMin')(state)
})

const mapDispatchToProps = {
  initialValues: {
  }
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formVenderMin',
    validate: validate
  }),
  lifecycle({
    componentDidMount() {
    },
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(MinVenderInfomationForm)